export default "<style>\n\n  container--field\n  {\n    \n  }\n\n  \n\n \n  \n\n</style>";